(() => {
  if (window.onlyGamesFeaturedCreators) return;
  window.onlyGamesFeaturedCreators = true;
  const instances = new WeakMap();
  const selector = '[data-featured-creators]';
  function mount(root) {
    if (instances.has(root)) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const cleanups = [];
    root.querySelectorAll('[data-creator-previews]').forEach((grid, index) => {
      const images = [...grid.querySelectorAll('img')];
      const pool = JSON.parse(grid.querySelector('[data-creator-image-pool]').textContent);
      if (pool.length <= images.length || !images.length) return;
      const queue = pool.slice(images.length);
      let cursor = 0;
      let pending = null;
      let disposed = false;
      const timer = setInterval(() => {
        const bounds = grid.getBoundingClientRect();
        if (disposed || pending || motion.matches || document.hidden || bounds.bottom <= 0 || bounds.top >= innerHeight) return;
        const image = images[cursor++ % images.length];
        const next = queue[0];
        const preload = new Image();
        pending = preload;
        preload.onload = () => {
          if (disposed) return;
          if (motion.matches) { pending = null; return; }
          image.classList.add('is-out');
          pending = setTimeout(() => {
            queue.shift();
            queue.push({ src: image.getAttribute('src'), alt: image.alt });
            image.src = next.src;
            image.removeAttribute('srcset');
            image.alt = next.alt;
            image.classList.remove('is-out');
            pending = null;
          }, 400);
        };
        preload.onerror = () => { queue.push(queue.shift()); pending = null; };
        preload.src = next.src;
      }, 2600 + index * 400);
      cleanups.push(() => {
        disposed = true;
        clearInterval(timer);
        if (pending instanceof Image) { pending.onload = null; pending.onerror = null; }
        else clearTimeout(pending);
      });
    });
    instances.set(root, () => { cleanups.forEach(fn => fn()); instances.delete(root); });
  }
  function scan(scope) {
    if (scope.matches?.(selector)) mount(scope);
    scope.querySelectorAll(selector).forEach(mount);
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(root => instances.get(root)?.());
  });
})();
